import NotificationPaths from 'Application/Notification/Constants/NotificationPaths'
import { INotification } from 'Application/Notification/store/types'

import Icon from 'Components/Icon'

import { useNavigate } from 'react-router-dom'

function NotificationListItem({
  messageBody,
  status,
  id,
  persianFirstAttemptAt,
  notificationReceiverQr,
}: INotification) {
  const navigate = useNavigate()

  const hasListed = notificationReceiverQr?.some(r => r.receiverStatus === 'Listed') ?? false
  const hasSeended = notificationReceiverQr?.some(r => r.receiverStatus === 'Seen') ?? false

  return (
    <div>
      <div
        className={`flex items-center justify-between px-6 py-3 `}
        style={hasListed ? { background: '#f3f5f7' } : {}}
      >
        <div
          className="flex gap-2 grow cursor-pointer"
          onClick={() => !hasSeended && navigate(`${NotificationPaths.NotificationInfo}/${id}`)}
        >
          <div className="flex items-center justify-center w-10 h-10 rounded-full text-primary bg-primary/10 hover:bg-primary/15 avatar-16 ">
            <Icon
              name="icon_request_notification"
              id="icon_request_notification"
              width={22}
              height={20}
            />
          </div>

          <div className="flex flex-col flex-grow text-right pl-2">
            <span className="text-base text-gray-800 leading-6 break-words">
              {(messageBody || '').replace(/<[^>]*>/g, '')}
            </span>

            <span className="text-sm text-gray-600 mt-1 text-right inline-flex items-center gap-1">
              <Icon name="icon_clock" id="icon_clock" style={{ paddingTop: '4px' }} />
              {persianFirstAttemptAt}
              {/* {(firstAttemptAtShamsi || "")} */}
            </span>
          </div>
        </div>

        <div className="flex flex-col items-end gap-2 shrink-0">
          {hasListed && <Icon className="circle_online" name="circle_online" />}
        </div>
      </div>
    </div>
  )
}

export default NotificationListItem
